"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QrCodePainter = void 0;
var round_1 = require("../../../util/round");
var qrcode_generator_1 = __importDefault(require("qrcode-generator"));
var PathBasedPainter_1 = require("../../PathBasedPainter");
/**
 * Implements drawing-related operations for QR codes.
 */
var QrCodePainter = /** @class */ (function (_super) {
    __extends(QrCodePainter, _super);
    function QrCodePainter() {
        var _this = _super.call(this, "qr-code") || this;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    QrCodePainter.prototype.loadResources = function (store, object) {
        var _this = this;
        store.load("qr-code", function () { return Promise.resolve(_this._getQrCode(store, object)); }, { hash: object.content + this._cellSizeOf(object) });
    };
    QrCodePainter.prototype.paintFill = function (store, object) {
        var ctx = store.layers.result.ctx;
        ctx.save();
        if (!object.stroke) {
            this.applyShadowSettings(ctx, object);
        }
        this._paintQrCode(ctx, store, object);
        ctx.restore();
    };
    QrCodePainter.prototype._paintQrCode = function (ctx, store, object) {
        var qrCode = store.require("qr-code");
        if (qrCode.status === "loaded") {
            ctx.save();
            ctx.drawImage(qrCode.result, 0, 0, round_1.round(object, this.scaledBaseWidthOf(object)), round_1.round(object, this.scaledBaseHeightOf(object)));
            ctx.restore();
        }
    };
    QrCodePainter.prototype._getQrCode = function (store, object) {
        var qrCode = qrcode_generator_1.default(0, object.errorCorrectionLevel || "M");
        qrCode.addData(object.content);
        qrCode.make();
        var margin = this._marginOf(object);
        var cells = this._cellCount(qrCode, object);
        var cellSize = this._cellSizeOf(object, qrCode);
        var canvasSize = { width: cellSize * cells, height: cellSize * cells };
        var canvas = store.canvasFor("qr-code", canvasSize);
        var ctx = canvas.getContext("2d");
        ctx.save();
        ctx.scale(cellSize, cellSize);
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, cells, cells);
        ctx.translate(margin, margin);
        qrCode.renderTo2dContext(ctx, 1);
        ctx.restore();
        return canvas;
    };
    ;
    QrCodePainter.prototype.tracePath = function (ctx, store, object) {
        ctx.rect(0, 0, this.scaledBaseWidthOf(object), this.scaledBaseHeightOf(object));
    };
    QrCodePainter.prototype._marginOf = function (object) {
        return object.margin || 4;
    };
    QrCodePainter.prototype._cellCount = function (libraryQrCode, object) {
        return libraryQrCode.getModuleCount() + this._marginOf(object) * 2;
    };
    QrCodePainter.prototype._cellSizeOf = function (object, qrCode) {
        if (qrCode === void 0) { qrCode = this._qrCodeFromObject(object); }
        return Math.ceil(this.scaledBaseSizeOf(object).width / this._cellCount(qrCode, object));
    };
    QrCodePainter.prototype._qrCodeFromObject = function (object) {
        var qrCode = qrcode_generator_1.default(0, object.errorCorrectionLevel || "M");
        qrCode.addData(object.content);
        qrCode.make();
        return qrCode;
    };
    QrCodePainter.prototype.shouldRepaint = function (previousData, newData) {
        return _super.prototype.shouldRepaint.call(this, previousData, newData)
            || newData.content !== previousData.content;
    };
    return QrCodePainter;
}(PathBasedPainter_1.PathBasedPainter));
exports.QrCodePainter = QrCodePainter;
//# sourceMappingURL=QrCodePainter.js.map